import BaseApi from '../base';

class QuestionnaireApi extends BaseApi {
  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getQuestionnaires(token) {
    return this.makeRequest(this.METHOD_GET, 'questionnaires', token);
  }

  /**
   * @param {string} token
   * @param {string} userId
   * @returns {Promise<*>}
   */
  async getUserAnswers(token, userId) {
    return this.makeRequest(this.METHOD_GET, `user/${userId}/answers`, token);
  }

  /**
   * @param {string} token
   * @param {string} id
   * @param {string} comment
   * @returns {Promise<*>}
   */
  async addAnswerComment(token, id, comment) {
    return this.makeRequest(this.METHOD_POST, `answer/${id}/comment`, token, { comment });
  }
}

export default QuestionnaireApi;
